///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import {
	globalLoadingActionCreators,
	errorManagerActionCreators,
	toastSuccessActionCreators,
	initKioskCreationImplantationActionCreators,
} from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'
import { uriList } from '../../routings/settings/RouteList'

const postKioskImplantation = function* ({ payload }) {
	const bodyMessage = payload.filters

	const user = yield select(selectIdsUser)
	const apiCall = R.POST_KIOSK_IMPLANTATION(payload.requestId, payload.queryParams)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMessage)

		yield put(initKioskCreationImplantationActionCreators.postKioskImplantationSuccess(data.data, payload.requestId))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationImplantationActionCreators.postKioskImplantationFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}
const getItemsCatalogGrowth = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_ITEMS_CATALOG_GROWTH(payload.requestId, payload.requestUrl)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(initKioskCreationImplantationActionCreators.getItemsCatalogGrowthSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationImplantationActionCreators.getItemsCatalogGrowthFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const putUnitActionWithId = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.PUT_UNIT_ACTION_WITH_ID(payload.requestId, payload.query, payload.arg)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, payload.caseList)

		yield put(initKioskCreationImplantationActionCreators.putUnitActionWithIdSuccess(data.data))

		yield put(toastSuccessActionCreators.hydrateToast(payload.toast))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskCreationImplantationActionCreators.putUnitActionWithIdFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const putValidateImplantation = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.PUT_VALIDATE_IMPLANTATION(payload.requestId)
	const redirectRequest =
		payload.redirectTest === 'customer'
			? `${uriList.initKiosks}${uriList.initKioskCustomerManager}${uriList.kioskAddPrices}/${payload.requestId}`
			: `${uriList.initKiosks}${uriList.initKioskBusinessManager}${uriList.kioskAddPrices}/${payload.requestId}`
	const msgParam = 'toast__initKiosk__kioskCreation_growth__validated'
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(initKioskCreationImplantationActionCreators.putValidateImplantationSuccess(data.data))

		yield put(toastSuccessActionCreators.hydrateToast(msgParam, redirectRequest))
	} catch (e) {
		if (e.response.data.errorCode === 1) {
			yield put(initKioskCreationImplantationActionCreators.putValidateImplantationFailure(e.response))
		} else if (e.response.data.errorCode === 2) {
			yield put(initKioskCreationImplantationActionCreators.putValidateImplantationFailure(e.response))
		} else {
			yield put(errorManagerActionCreators.createError(e.response))
		}
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.POST_KIOSK_IMPLANTATION, postKioskImplantation)
	yield takeLatest(ActionsTypes.GET_ITEMS_CATALOG_GROWTH, getItemsCatalogGrowth)
	yield takeLatest(ActionsTypes.PUT_UNIT_ACTION_WITH_ID, putUnitActionWithId)
	yield takeLatest(ActionsTypes.PUT_VALIDATE_IMPLANTATION, putValidateImplantation)
}

export default sagas
